import {Button, Checkbox, Flex, Form, Input, message, Modal, Select, Space, Table, Typography} from 'antd';
import React, {useEffect, useState} from 'react'
import useCustomer from '../../hooks/useCustomer';
import AxiosService from '../../services/APIService';
import dayjs from 'dayjs';
import {connect} from 'react-redux';
import useWhiteLabel from '../../hooks/useWhiteLabel';

function WLAnnouncement({isLoading}) {
    const [form] = Form.useForm();
    const [modalVisible, setModalVisible] = useState(false);
    const apiService = new AxiosService();
    const [listData, setListData] = useState([]);
    const [selectedItems,setSelectedItems] = useState([]);
    
    const {whiteLabel} = useWhiteLabel()

    const onFinish = (val) => {
        apiService.post("/notification/announcement-wl", {
            message: val.message,
            whiteLabel: val.whiteLabel
        })
            .then(res => {
                fetchMessage();
                message.success(res.message);
                form.resetFields();
                setSelectedItems([]);
            })
            .catch(e => message.error(e.message));
    };

    useEffect(() => {
        fetchMessage();
    }, []);

    const columns = [
        {
            title: "#",
            dataIndex: "count",
            key: "count"
        },
        {
            title: "Message",
            dataIndex: "msg",
            key: "msg"
        },
        {
            title: "Total User",
            dataIndex: "total",
            key: "total"
        }
    ];

    const fetchMessage = () => {
        apiService.get('/notification/announcement-wl')
            .then(res => {
                const data = res.data.map((dt, i) => ({
                    count: i + 1,
                    key: dt._id,
                    msg: dt._id,
                    total: dt?.data?.length,
                    chld: dt.data
                }));
                setListData(data);
            })
            .catch(e => console.log(e));
    };

    const handleEditCancel = () => {
        setModalVisible(false);
    };

    const handleSelectChange = (selectedValues) => {
        if (selectedValues.includes('selectAll')) {
            if (selectedItems.length === whiteLabel.length) {
                setSelectedItems([]);
                form.setFieldsValue({ customers: [] });
            } else {
                const allValues = whiteLabel.map(dt => dt?.user?._id);
                setSelectedItems(allValues);
                form.setFieldsValue({ customers: allValues });
            }
        } else {
            setSelectedItems(selectedValues);
        }
    };

    const expandedRowRender = (dt) => {
        const data = dt?.chld?.map((dt, i) => {
            return ({
                index: i + 1,
                name: dt.user.fullName,
                sentAt: dayjs(dt.created_at).format("DD-MM-YYYY HH:mm")
            });
        });

        const clm = [
            {
                title: "#",
                dataIndex: "index",
                key: "index"
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name"
            },
            {
                title: "Sent At",
                dataIndex: "sentAt",
                key: "sentAt"
            },
        ];

        return <Table dataSource={data} columns={clm} />;
    };

    return (
        <>
            <Typography.Title level={3} className="page-title">Announcement</Typography.Title>
            <Modal
                title="Announcement"
                open={modalVisible}
                onCancel={handleEditCancel}
                footer={[]}
                width={500}
            >
                <Form
                    name="control-hooks"
                    onFinish={onFinish}
                    layout='vertical'
                    form={form}
                >
                    <Form.Item
                        name="message"
                        label="Message"
                        rules={[
                            {
                                required: true,
                                message: "Message Required"
                            },
                        ]}
                    >
                        <Input placeholder="Enter Message For White Labels" />
                    </Form.Item>
                    <Form.Item
                        name="whiteLabel"
                        label="Select White Labels"
                    >
                        <Select
                            mode="multiple"
                            placeholder="Select White Labels"
                            value={selectedItems}
                            onChange={handleSelectChange}
                            options={[
                                {
                                    value: 'selectAll',
                                    label: (
                                        <Checkbox
                                            checked={selectedItems.length === whiteLabel.length}
                                        >
                                            Select All
                                        </Checkbox>
                                    )
                                },
                                ...whiteLabel.map(dt => ({
                                    value: dt?.user?._id,
                                    label: dt?.name
                                }))
                            ]}
                            filterOption={(input, option) =>
                                option?.label?.props?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                option?.value?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        />
                    </Form.Item>
                    <Space>
                        <Button type="primary" htmlType="submit">
                            Send
                        </Button>
                    </Space>
                </Form>
            </Modal>
            <Flex justify="end" style={{ marginBottom: "20px" }}>
                <Button type='primary' onClick={() => setModalVisible(true)}>Create New Message</Button>
            </Flex>
            <Table columns={columns} dataSource={listData} loading={isLoading} expandable={{
                expandedRowRender,
            }} />
        </>
    );
}

const mapStateToProps = ({ loading }) => {
    const { isLoading } = loading;
    return { isLoading };
};

export default connect(mapStateToProps, {})(WLAnnouncement)